// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { f_tool_scale_get, f_tool_scale_list } from '@/utils/scale';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  try {
    let v_thepkg = "";
    const v_authTOken =Cookies.get('authToken');
    v_thepkg = f_tool_scale_list([v_authTOken||'']); 
    const response = await request<any>('/dopost/bh/port/1005', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/text',
        },
        data: v_thepkg,
        ...(options || {}),
      });
    if (response && response.oret =="1") {
      return (
      {        
        data: {
          name: '猋行',
          avatar:
            'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
          userid: '00000001',
          email: 'antdesign@alipay.com',
          signature: '海纳百川，有容乃大',
          title: '交互专家',
          group: '蚂蚁金服－某某某事业群－某某平台部－某某技术部－UED',
          tags: [
            {
              key: '0',
              label: '很有想法的',
            },
            {
              key: '1',
              label: '专注设计',
            },
            {
              key: '2',
              label: '辣~',
            },
            {
              key: '3',
              label: '大长腿',
            },
            {
              key: '4',
              label: '川妹子',
            },
            {
              key: '5',
              label: '海纳百川',
            },
          ],
          notifyCount: 12,
          unreadCount: 11,
          country: 'China',
          access: 'admin',//getAccess(),
          geographic: {
            province: {
              label: '浙江省',
              key: '330000',
            },
            city: {
              label: '杭州市',
              key: '330100',
            },
          },
          address: '西湖区工专路 77 号',
          phone: '0752-268888888',
        },
      }
      );
    }else{
      return null;
    }

  } catch (error) {
    console.error('Failed to fetch current user:', error);
    throw error;
  }
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  try {
    // Remove token cookie
    Cookies.remove('authToken');
    
    const response = await request<Record<string, any>>('/api/login/outLogin', {
      method: 'POST',
      ...(options || {}),
    });
    
    return response;
  } catch (error) {
    // Even if API call fails, still remove the cookie
    Cookies.remove('authToken');
    throw error;
  }
}

/** 登录接口 POST /dopost/bh/port/10000 (proxied to https://www.biaohang.net/dopost/bh/port/10000) */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  //打包请求参数
  let v_thepkg ="";
  const v_sitemyid = "1";
  const v_logintype = body.type;

  if(v_logintype == "account"){
    const v_logintype_num = "1";
    const v_username = body.username || '';
    const v_userpass = body.password || '';
    v_thepkg = f_tool_scale_list([v_sitemyid, v_logintype_num, v_username, v_userpass]);
  }else if(v_logintype =="mobile"){
    const v_logintype_num = "2";
    const v_userphone = body.mobile || '';
    const v_userphonecode = body.captcha || '';
    v_thepkg = f_tool_scale_list([v_sitemyid, v_logintype_num, v_userphone, v_userphonecode]);
  }else{
    console.log("else: login");
    return;
  }
  const response = await request<any>('/dopost/bh/port/1000', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/text',
    },
    data: v_thepkg,
    ...(options || {}),
  });
  
  // Parse the response and check oret field
  if (response && response.oret =="1") {
    // Extract token from response if it exists
    const token = response.info.token || null;
    
    // Save token to cookie if it exists
    if (token) {
      Cookies.set('authToken', token, { expires: 1, path: '/' }); // Expires in 1 days
    }else{
      return {
        status: 'error',
        type: body.type,
        currentAuthority: 'guest',
      };
    }
    
    return {
      status: 'ok',
      type: body.type,
      currentAuthority: 'admin', // Default to admin, can be customized based on response
      token: token // Include token in response
    };
  } else {
    return {
      status: 'error',
      type: body.type,
      currentAuthority: 'guest',
    };
  }
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}
/** 获取设备列表 POST /dopost/bh/port/1002 (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function devicelist(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken = "BHtoken";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 10).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.devicemyid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.deviceid || "";
  const v_queryParam05=params.devicegid || "";
  const v_queryParam06=params.boxid || "";
  const v_queryParam07=params.boxsize || "";
  const v_queryParam08=params.open01 || "";
  const v_queryParam09=params.online01 || "";
  const v_queryParam10=params.extparam || "";
  const v_queryParam11=params.see || "";
  const v_queryParam12=params.see || "";  
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05, v_queryParam06, v_queryParam07, v_queryParam08, v_queryParam09, v_queryParam10, v_queryParam11, v_queryParam12]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/1002', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/** 设备录入 POST /dopost/bh/port/1002 */
export async function DeviceInsert(value: any, options?: { [key: string]: any }) {
  console.log(options);
  let v_thepkg = "";
  const v_oprgid = "2";
  const v_usertoken = "BHtoken";
  const v_deviceid = value.deviceid || "";
  const v_boxid = value.boxid || "";
  const v_boxsize = value.boxsize || "";
  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();

  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_deviceid, v_boxid, v_boxsize,v_extendParam,v_password]);
  const v_theres =await request<any>('/dopost/bh/port/1002', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret1002.2', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret1002.2', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/** 设备编辑 POST /dopost/bh/port/1002 */
export async function DeviceUpdate(value: any, options?: { [key: string]: any }) {
  console.log(value);
  let v_thepkg = "";
  const v_oprgid = "3";
  const v_usertoken = "BHtoken";
  const v_deviceid = value.deviceid || "";
  const v_boxid = value.boxid || "";
  const v_boxsize = value.boxsize || "";
  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();
  const v_devicemyid = value.devicemyid || "";
  const v_open01 = value.open01 || "";

  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_deviceid, v_boxid, v_boxsize,v_extendParam,v_password,v_open01,v_devicemyid]);
  const v_theres =await request<any>('/dopost/bh/port/1002', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret1002.3', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret1002.3', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}

/** 批量操作 POST /dopost/bh/port/1003 */
export async function BatchOpr(value: any, options?: { [key: string]: any }) {
  //console.log(value);
  
  let v_thepkg = "";  
  const v_usertoken = "BHtoken";
  const v_deviceidlist = f_tool_scale_get(value,1);
  const v_oprParam = f_tool_scale_get(value,2);
  const v_oprgid = f_tool_scale_get(v_oprParam,1);//操作类型 
  const v_extendParam =f_tool_scale_get(v_oprParam,2);//操作类型附加参数

  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_deviceidlist, v_extendParam]);
  const v_theres =await request<any>('/dopost/bh/port/1003', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret1003.1', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret1003.1', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}


/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
